import clsx from "clsx";

export default function Section({
  id,
  title,
  className = "",
  withDivider = false,
  children,
}) {
  return (
    <section
      id={id}
      className={clsx(
        "py-10 md:py-14 bg-black",
        withDivider && "border-t border-neutral-800",
        className
      )}
    >
      <div className="max-w-6xl mx-auto px-4">
        {title ? (
          <h2 className="text-2xl md:text-3xl font-extrabold mb-6">{title}</h2>
        ) : null}
        {children}
      </div>
    </section>
  );
}
